import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCard,
    { staticClass: "rounded-xl soft-border", attrs: { flat: "" } },
    [
      _c(
        VExpansionPanels,
        {
          staticClass: "rounded-xl soft-border inner-bg",
          attrs: { accordion: "", flat: "" },
          model: {
            value: _vm.expanded,
            callback: function ($$v) {
              _vm.expanded = $$v
            },
            expression: "expanded",
          },
        },
        [
          _vm._l(_vm.displayedSections, function (section) {
            return _c(
              VExpansionPanel,
              { key: section.id, staticClass: "no-shadow" },
              [
                _c(VExpansionPanelHeader, { staticClass: "py-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center justify-space-between w-100",
                    },
                    [
                      _c("span", { staticClass: "truncate" }, [
                        _vm._v(_vm._s(section.title)),
                      ]),
                      _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.removeSection(section.id)
                            },
                          },
                        },
                        [_c(VIcon, [_vm._v("mdi-delete-outline")])],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  VExpansionPanelContent,
                  { staticClass: "pt-0" },
                  [
                    _vm._l(section.ranges, function (range, index) {
                      return _c(
                        "div",
                        { key: range.id, staticClass: "py-1" },
                        [
                          _c(
                            VRow,
                            { attrs: { align: "center", "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                {
                                  staticClass: "pr-sm-2 pr-1",
                                  attrs: { cols: "4", sm: "3" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "caption grey--text text--darken-2",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            range.default === true
                                              ? "Valor por defecto"
                                              : range.isNull === true
                                              ? "Valor si es null"
                                              : "Valor <="
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              range.default !== true && range.isNull !== true
                                ? _c(
                                    VCol,
                                    { attrs: { cols: "3", sm: "3" } },
                                    [
                                      _c(VTextField, {
                                        staticClass:
                                          "ma-0 rounded-input text-center mr-2",
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          rules: _vm.rulesFor(section, index),
                                        },
                                        model: {
                                          value: range.value,
                                          callback: function ($$v) {
                                            _vm.$set(range, "value", $$v)
                                          },
                                          expression: "range.value",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VCol,
                                {
                                  attrs: {
                                    cols:
                                      range.default === true ||
                                      range.isNull === true
                                        ? 7
                                        : 4,
                                    sm:
                                      range.default === true ||
                                      range.isNull === true
                                        ? 8
                                        : 5,
                                  },
                                },
                                [
                                  _c(VTextField, {
                                    staticClass: "ma-0 rounded-input",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      "hide-details": "auto",
                                      placeholder:
                                        range.default === true
                                          ? "Valor por defecto"
                                          : range.isNull === true
                                          ? "Resultado si es null"
                                          : "Resultado",
                                    },
                                    model: {
                                      value: range.output,
                                      callback: function ($$v) {
                                        _vm.$set(range, "output", $$v)
                                      },
                                      expression: "range.output",
                                    },
                                  }),
                                ],
                                1
                              ),
                              range.default !== true && index !== 0
                                ? _c(
                                    VCol,
                                    {
                                      staticClass: "pl-1 text-right",
                                      attrs: { cols: "1", sm: "1" },
                                    },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.removeRange(
                                                section.id,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-minus-circle-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-end pt-1" },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              icon: "",
                              disabled: section.ranges.length >= 10,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addRange(section.id)
                              },
                            },
                          },
                          [_c(VIcon, [_vm._v("mdi-plus")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            )
          }),
          _vm.sectionsLocal.length === 0
            ? _c(
                "div",
                { staticClass: "text-center grey--text text--darken-1 py-6" },
                [_vm._v(" Sin atributos seleccionados ")]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }